export const DecimalFilter = {
  filters: {
    decimal (value) {
      return value.toFixed(1)
    }
  }
}